import Vue from 'vue'
import ViewUI from 'view-design'
import axios from 'axios'
import App from './App.vue'

import 'view-design/dist/styles/iview.css'
import './assets/common.css'

Vue.config.productionTip = false
Vue.use(ViewUI)

Vue.prototype.$http = axios.create({
  timeout: 20000,
  headers: { 'Content-Type': 'multipart/form-data' }
})

new Vue({
  render: h => h(App),
}).$mount('#app')
